import { useLazyQuery } from "@apollo/client/react";import React, { useState } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import { RenderInputByTypeMobile } from '../../../../components/formGroupGenerator/RenderInputByTypeMobile';
import toast from 'react-hot-toast';
import { useVisita } from '../../../../context/VisitaContext';
import { handleChangeImageVisita } from '../../utils/handleChangeImageVisita';
import { tipoArchivoVisita } from '../../constants/TipoArchivosVisita';

import { GET_ARCHIVO_VISITA } from '../../../../data/graphQL/queries/MisVisitas/getArchivoVisita';
import DocumentViewer from '../../../../components/DocumentViewer';
import { useDeleteArchivoVisita } from '../../hooks/useDeleteArchivoVisita';

const MultipleAdjuntos = ({ input, archivos = [], handleChange, idTipoArchivo }) => {
  const { deleteArchivo } = useDeleteArchivoVisita();

  const { visita, saveArchivoVisita } = useVisita();

  const [fileToView, setFileToView] = useState(undefined);
  const resetFileToView = () => setFileToView(undefined);

  const [fetchArchivoVisita, { loading }] = useLazyQuery(GET_ARCHIVO_VISITA, {
    fetchPolicy: 'no-cache',
    onError: () => toast.error('Error al obtener el archivo')
  });

  const handleViewFile = async (file, index) => {

    if (file.archivo && file.contentType) {
      setFileToView(file);
      return;
    }

    try {
      const { data } = await fetchArchivoVisita({
        variables: { idArchivoVisita: file.idArchivo }
      });

      if (data?.archivoVisita?.valorEsperado) {
        const updatedFile = data.archivoVisita.valorEsperado;

        const newFiles = [...archivos];
        newFiles[index] = { ...file, ...updatedFile };

        handleChange(input.name, newFiles);

        setFileToView(newFiles[index]);
      } else {
        toast.error('No se pudo obtener el archivo');
      }
    } catch (error) {
      console.error(error);
      toast.error('Error al visualizar el archivo');
    }
  };

  const handleRemoveFile = (idArchivo) => {
    deleteArchivo({
      idArchivo,
      name: input.name,
      archivos,
      handleChange
    });
  };

  const onChangeImage = async (name, fileValue) => {
    handleChangeImageVisita({
      saveArchivoVisita,
      name,
      fileValue,
      idVisita: visita.idVisita,
      handleChange,
      archivos,
      idTipoArchivo: idTipoArchivo || tipoArchivoVisita.DOCUMENTOS
    });
  };

  return (
    <>
            <RenderInputByTypeMobile
        label={input.displayName}
        value={null}
        handleChange={onChangeImage}
        input={input} />
      
            <Box mt={2} display="flex" flexDirection="column" gap={1}>
                {archivos?.map((file, index) =>
        <Box
          key={index}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          sx={{ gap: 1 }}>
          
                        <Box
            display="flex"
            alignItems="center"
            flex="1"
            sx={{
              backgroundColor: '#f5f5f5',
              borderRadius: '6px',
              padding: '6px 10px',
              overflow: 'hidden'
            }}>
            
                            <AttachFileIcon fontSize="small" sx={{ mr: 1, color: '#555' }} />
                            <Typography
              variant="body2"
              noWrap
              sx={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>
              
                                {file.titulo || file.name || 'Archivo'}
                            </Typography>
                        </Box>
                        <Box display="flex" alignItems="center" gap={0.5}>
                            <IconButton size="small" onClick={() => handleViewFile(file)}>
                                <VisibilityIcon fontSize="small" />
                            </IconButton>
                            {!input.disabled && <IconButton size="small" onClick={() => handleRemoveFile(file.idArchivo)}>
                                <DeleteIcon fontSize="small" color="error" />
                            </IconButton>}
                        </Box>
                    </Box>
        )}
            </Box>
            {!!fileToView &&
      <DocumentViewer
        data={fileToView}
        setOpenDlg={resetFileToView} />

      }
        </>);

};

export default MultipleAdjuntos;